import React, { useEffect, useState } from 'react';
import { withWrapper } from '@shared/react';
import { MainLayoutProvider, useMainLayout } from './lib';
import { Sidebar } from './components';
import { AppLoader } from '@shared/UI';
import classNames from 'classnames';
import { DailySettlementProvider } from '@shared/providers/DailySettlementProvider';
import './MainLayout.scss';
import { Snackbar, SnackbarContent } from '@mui/material';
import snackbarStore from './store/snackbar-store';
import { useLocation } from 'react-router-dom';

export const MainLayoutContent: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { sidebarFixed, routeGroups } = useMainLayout();

    const { isSnackbarOpen, snackbarMessage, setIsSnackbarOpen } = snackbarStore();

    useEffect(() => {
        if (isSnackbarOpen) {
            const timer = setTimeout(() => {
                setIsSnackbarOpen(false); // Close snackbar after 6 seconds
            }, 6000);
            return () => clearTimeout(timer); // Cleanup timeout on component unmount
        }
    }, [isSnackbarOpen, setIsSnackbarOpen]);

    if (!routeGroups) return <AppLoader />;
    const location = useLocation();
    return (
        <>
            {!location.pathname.includes('LoginWizard') ? <Sidebar /> : null}
            <main
                className={classNames(
                    'widget-main-layout',
                    !location.pathname.includes('LoginWizard') ? { sidebarFixed } : 'noSideBar',
                )}
            >
                <Snackbar
                    open={isSnackbarOpen}
                    autoHideDuration={6000} // Hide snackbar after 6 seconds
                    onClose={() => setIsSnackbarOpen(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: snackbarMessage.includes('Failed') ? 'red' : 'rgb(162 237 164)',
                            color: 'white',
                        }}
                        message={snackbarMessage}
                    />
                </Snackbar>
                <div className='widget-main-layout__content'>{children}</div>
            </main>
        </>
    );
};
const MainLayoutWithProvider = withWrapper(MainLayoutProvider)(MainLayoutContent);
export const MainLayout = withWrapper(DailySettlementProvider)(MainLayoutWithProvider);
